<template>
  <v-dialog v-model="opened" max-width="800" persistent>
    <v-form
      ref="form"
      v-model="valid"
      :readonly="!canEdit"
      @submit.prevent="save()"
    >
      <v-card :loading="loadingData" :disabled="loadingData">
        <v-card-title class="headline">
          {{ !id ? " Tambah" : "Ubah" }} Konfigurasi Komisi
          <v-btn icon @click="close()" class="ml-auto">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row justify="center" no-gutters>
              <v-col cols="12" md="10">
                <v-autocomplete
                  label="Role"
                  required
                  dense
                  outlined
                  v-model="data.role_id"
                  :items="listRoles"
                  item-text="name"
                  item-value="id"
                  :rules="rules.role_id"
                  clearable
                ></v-autocomplete>
              </v-col>
            </v-row>
            <v-row justify="center" no-gutters>
              <v-col cols="12" md="10">
                <v-text-field
                  label="Config Type"
                  required
                  dense
                  outlined
                  v-model="data.config_type"
                  :rules="rules.config_type"
                ></v-text-field>
              </v-col>
            </v-row>
            <!-- min value -->
            <v-row justify="center" no-gutters>
              <v-col cols="12" md="10">
                <v-text-field
                  label="Min Value"
                  dense
                  outlined
                  v-model.number="data.min_value"
                  type="number"
                ></v-text-field>
              </v-col>
            </v-row>
            <!-- max value -->
            <v-row justify="center" no-gutters>
              <v-col cols="12" md="10">
                <v-text-field
                  label="Max Value"
                  dense
                  outlined
                  v-model.number="data.max_value"
                  type="number"
                ></v-text-field>
              </v-col>
            </v-row>
            <!-- percentage -->
            <v-row justify="center" no-gutters>
              <v-col cols="12" md="10">
                <v-text-field
                  label="Percentage"
                  dense
                  outlined
                  v-model.number="data.percentage"
                  type="number"
                ></v-text-field>
              </v-col>
            </v-row>
            <!-- fixed amount -->
            <v-row justify="center" no-gutters>
              <v-col cols="12" md="10">
                <v-text-field
                  label="Fixed Amount"
                  dense
                  outlined
                  v-model.number="data.fixed_amount"
                  type="number"
                ></v-text-field>
              </v-col>
            </v-row>
            <!-- description -->
            <v-row justify="center" no-gutters>
              <v-col cols="12" md="10">
                <v-textarea
                  label="Deskripsi"
                  dense
                  outlined
                  v-model="data.description"
                  rows="3"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-row no-gutters>
            <v-col cols="12" align="end">
              <v-btn
                depressed
                class="ma-1"
                :disabled="loading"
                @click="close()"
              >
                <v-icon small left>mdi-close</v-icon>
                Tutup
              </v-btn>
              <v-btn
                v-if="canEdit"
                type="submit"
                color="success"
                depressed
                class="ma-1"
                :loading="loading"
                :disabled="loading"
                @click.prevent="save()"
              >
                <v-icon small left>mdi-content-save</v-icon>
                Simpan
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import ApiService from "@/core/services/api.service";
import { slugify } from "@/core/utils";

export default {
  async mounted() {
    const roles = await ApiService.get("role/list");
    this.listRoles = roles.data;

    const paymentMethods = await ApiService.get("payment-method/list");
    this.listPaymentMethods = paymentMethods.data;

    const banks = await ApiService.get("bank/list");
    this.listBanks = banks.data;
  },
  data() {
    return {
      action: "create",
      id: null,
      opened: false,
      loading: false,
      loadingData: false,
      valid: true,
      data: {
        role_id: null,
        config_type: null,
        min_value: null,
        max_value: null,
        percentage: null,
        fixed_amount: null,
        description: null
      },
      rules: {
        config_type: [
          v => !!v || "Config Type is required",
          v => (v && v.length <= 100) || "Name must be less than 10 characters"
        ],
        role_id: [
          v => !!v || "Role is required"
        ]
      }
    };
  },
  props: {
    module: {
      type: String
    },
    success: {
      type: Function,
      default: function() {}
    }
  },
  methods: {
    open(id) {
      this.opened = true;
      setTimeout(() => {
        this.$refs.form.reset();
        if (id) {
          this.getData(id);
        }
      }, 1);
    },
    async getData(id) {
      this.loadingData = true;
      this.id = id;
      ApiService.get("commission-config?id=" + id)
        .then(({ data }) => {
          this.data = {
            role_id: data.role_id,
            config_type: data.config_type,
            min_value: data.min_value,
            max_value: data.max_value,
            percentage: data.percentage,
            fixed_amount: data.fixed_amount,
            description: data.description
          };
          this.loadingData = false;
        })
        .catch(({ response }) => {
          if (response.data) {
            this.handleError(response.data);
          }
          this.loadingData = false;
        });
    },
    async save() {
      this.$refs.form.validate();
      if (this.valid) {
        this.loading = true;
        const action = !this.id ? "post" : "update";
        let url = "commission-config";
        if (this.id) {
          url = url + "?id=" + this.id;
        }
        ApiService[action](url, this.data)
          .then(({ data }) => {
            if (data.id) {
              this.loading = false;
              this.success(data);
              this.$swal.fire({
                icon: "success",
                title: "Berhasil",
                text: "Data berhasil disimpan",
                showConfirmButton: false,
                timer: 3000
              });
              this.close();
            }
          })
          .catch(({ response }) => {
            if (response.data) {
              this.handleError(response.data);
            }

            this.loading = false;
          });
      }
    },
    handleError(data) {
      if (data.error) {
        this.$swal.fire({
          icon: "warning",
          title: "Terjadi kesalahan",
          text: data.error,
          showConfirmButton: true,
          timer: 5000
        });
      }
    },
    close() {
      this.opened = false;
      this.id = null;
      this.$refs.form.reset();
    }
  },
  watch: {
    ["data.name"](value) {
      this.data.slug = value ? slugify(value) : null;
    }
  },
  computed: {
    canEdit() {
      if (
        this.id &&
        !this.$store.getters.hasPermission(this.module, "update")
      ) {
        return false;
      }

      return true;
    }
  }
};
</script>
